/**
 * @file: DocPage.js
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import Spinner from '../../util/spinner-shim'
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import withAppStore from '../../util/withAppStore'

import AppStore from '../../stores/AppStore'
import AppDispatcher from '../../dispatchers/AppDispatcher'

import styles from '../../../css/devicePage.module.css'

function DocPage (props) {
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const category = searchParams.get('category')

  const getDocs = React.useCallback(() => {
    const {
      locale: {
        language
      } = { language: 'en' },
    } = AppStore.getUser()

    AppDispatcher.dispatch({
      action: 'get-docs',
      params: {
        category,
        language
      },
    })
  }, [category])

  const goBack = React.useCallback(() => {
    navigate('/support')
  }, [navigate])

  React.useEffect(() => {
    window.scrollTo(0, 0) // start at top
    getDocs()
  }, [getDocs])

  const {
    auth: { logout: logoutFn },
    intl: { formatMessage },
    route: { path: page },
  } = props

  const {
    data: {
      docs: {
        docs,
        docsReady = false,
      } = {},
    },
  } = AppStore

  const logout = () => logoutFn(navigate)

  let documentLinks

  if (docsReady) {
    if (docs.length) {
      documentLinks = docs
        .sort((a, b) => `${a.title} ${a.model_numbers}`.localeCompare(`${b.title} ${b.model_numbers}`))
        .map((doc) => (
          <section key={doc.id}>
            <Link
              to={`/docs/${doc.id}`}
            >
              <section
                className={styles.settingButtonCustomer}
                style={{
                  background: 'white !important',
                  borderRadius: '6px',
                  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.5)',
                  color: '#284047 !important',
                  display: 'flex',
                  fill: '#284047 !important',
                  font: 'bold 22px Source Sans Pro, sans-serif',
                  fontWeight: 'bold',
                  height: '90px',
                  marginBottom: '12px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  textAlign: 'center',
                  textDecoration: 'none',
                  minWidth: '288px',
                }}
              >
                {doc.title}
                <br />
                {doc.model_numbers}
              </section>
            </Link>
          </section>
        ))
    } else {
      documentLinks = <div style={{ marginLeft: '40%', marginTop: '20vh', color: 'red' }}><i className='fa fa-bug fa-5x' /></div>
    }
  } else {
    documentLinks = (
      <Spinner
        key='spinner'
        name='double-bounce'
        style={{ width: '30px', marginLeft: 'auto', marginRight: 'auto' }}
      />
    )
  }

  const GUIDE = formatMessage({ id: 'support.guide', defaultMessage: 'Guide' })
  const STATION_SETUP = formatMessage({ id: 'support.station.setup', defaultMessage: 'Station Setup' })

  const title = {
    guide: GUIDE,
    stationSetup: STATION_SETUP,
  }[category]

  return (
    <div>
      <Helmet><title>{title || props.pages.DocPage}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        name={title}
        page={page}
        logOut={logout}
      />
      <div className={styles.pageWidth}>
        <div>
          {documentLinks}
        </div>
        <div className={styles.endSpace} />
      </div>
      <Footer />
    </div>
  )
}

DocPage.propTypes = {
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
  pages: PropTypes.object,
}

export default withAppStore(injectIntl(DocPage))
